export const NO_SUCCESS_MESSAGE = "";
export const NOIFRAME_SUCCESS_MESSAGE =
  "Thank you for playing! Come back tomorrow for a new question.";
export const DEFAULT_SUCCESS_MESSAGE =
  "Your entry has been successfully submitted. " + NOIFRAME_SUCCESS_MESSAGE;
export const NO_ERROR_MESSAGE = "";
export const NO_ANSWER_ERROR_MESSAGE = "An answer was not selected.";
export const ALREADY_SUBMITTED_ERROR_MESSAGE =
  "Your submission has already been entered.  Try again tomorrow.";
export const SOURCE_ERROR_MESSAGE = "Your submission cannot be submitted.";
export const ANALYTICS_CATEGORY = "Q&AUSA";

export const AD_MORE_TIME_CLICKED = 1;
export const AD_REPLAY_CLICKED = 2;
export const AD_FINAL_RESULTS = 3;
export const AD_BONUS_CHANCE_VIDEO = 4;
export const AD_SHOW_HINT_CLICKED = 5;


// WEBPACK FOOTER //
// ./src/utils/constants.js